module.exports = __webpack_public_path__ + "static/img/com_01.29d71ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/com_01.png
// module id = 31RA
// module chunks = 12